import { DOCUMENT } from '@angular/common';
import {
    Component,
    ElementRef,
    EventEmitter,
    HostListener,
    Inject,
    Input,
    NgZone,
    OnDestroy,
    OnInit,
    Output,
} from '@angular/core';

import { Language } from '@ridango/core';
import { keyCode } from '@ridango/core/lib/enums/keyboard.enum';

@Component({
    selector: 'ridango-header-menu-item',
    templateUrl: './header-menu-item.component.html',
    styleUrls: ['./header-menu-item.component.scss'],
})
export class HeaderMenuItemComponent implements OnInit, OnDestroy {
    @Input() showIcon = true;
    @Input() selected: Language;
    @Input() languages: Language[];
    @Output() onLanguageSelected = new EventEmitter<Language>();

    isOpened = false;

    constructor(
        public eRef: ElementRef,
        private zone: NgZone,
        @Inject(DOCUMENT) private document: Document,
        @Inject('ENV') public env: any
    ) {}

    ngOnInit() {
        this.zone.runOutsideAngular(() => this.document.addEventListener('click', this.onClickOut));
    }

    ngOnDestroy() {
        this.zone.runOutsideAngular(() => this.document.removeEventListener('click', this.onClickOut));
    }

    onClickOut = (event) => {
        if (!this.eRef.nativeElement.contains(event.target)) {
            this.zone.run(() => (this.isOpened = false));
        }
    };

    @HostListener('keydown', ['$event'])
    handleKeydown(event: KeyboardEvent) {
        if (event.keyCode === keyCode.ESCAPE) {
            this.isOpened = false;
        }
    }

    /* Before we were passing the $event for the function open Clicked() but I
     think we can use a simple toggle for this case */
    openClicked() {
        /*this.isOpened = true;*/
        this.isOpened = !this.isOpened;
    }

    selectLanguage(event, lang: Language) {
        this.isOpened = false;
        this.onLanguageSelected.emit(lang);
        event.stopPropagation();
    }
}
